import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import all locale files
import en_translation from './locales/en/translation.json';
import en_auth from './locales/en/auth.json';
import en_devices from './locales/en/devices.json';
import en_users from './locales/en/users.json';
import en_errors from './locales/en/errors.json';
import en_ui from './locales/en/ui.json';
import en_messages from './locales/en/messages.json';
import en_reports from './locales/en/reports.json';
import en_menu from './locales/en/menu.json';
import en_home from './locales/en/home.json';
import en_settings from './locales/en/settings.json';
import en_analytics from './locales/en/analytics.json';
import en_provisioning from './locales/en/provisioning.json';
import en_onboarding from './locales/en/onboarding.json';
import en_commands from './locales/en/commands.json';
import en_templates from './locales/en/templates.json';
import en_configurations from './locales/en/configurations.json';
import en_discrepancies from './locales/en/discrepancies.json';
import en_divergenceLogs from './locales/en/divergenceLogs.json';
import en_bling from './locales/en/bling.json';
import en_analysisReports from './locales/en/analysisReports.json';
import en_dockLoading from './locales/en/dockLoading.json';
import en_dockFleetOverview from './locales/en/dockFleetOverview.json';
import en_logisticsOps from './locales/en/logisticsOps.json';
import en_assets from './locales/en/assets.json';
import en_supportWidget from './locales/en/supportWidget.json';
import en_permissions from './locales/en/permissions.json';

import pt_BR_translation from './locales/pt-BR/translation.json';
import pt_BR_auth from './locales/pt-BR/auth.json';
import pt_BR_devices from './locales/pt-BR/devices.json';
import pt_BR_users from './locales/pt-BR/users.json';
import pt_BR_errors from './locales/pt-BR/errors.json';
import pt_BR_ui from './locales/pt-BR/ui.json';
import pt_BR_messages from './locales/pt-BR/messages.json';
import pt_BR_reports from './locales/pt-BR/reports.json';
import pt_BR_menu from './locales/pt-BR/menu.json';
import pt_BR_home from './locales/pt-BR/home.json';
import pt_BR_settings from './locales/pt-BR/settings.json';
import pt_BR_analytics from './locales/pt-BR/analytics.json';
import pt_BR_provisioning from './locales/pt-BR/provisioning.json';
import pt_BR_onboarding from './locales/pt-BR/onboarding.json';
import pt_BR_commands from './locales/pt-BR/commands.json';
import pt_BR_templates from './locales/pt-BR/templates.json';
import pt_BR_configurations from './locales/pt-BR/configurations.json';
import pt_BR_discrepancies from './locales/pt-BR/discrepancies.json';
import pt_BR_divergenceLogs from './locales/pt-BR/divergenceLogs.json';
import pt_BR_bling from './locales/pt-BR/bling.json';
import pt_BR_analysisReports from './locales/pt-BR/analysisReports.json';
import pt_BR_dockLoading from './locales/pt-BR/dockLoading.json';
import pt_BR_dockFleetOverview from './locales/pt-BR/dockFleetOverview.json';
import pt_BR_logisticsOps from './locales/pt-BR/logisticsOps.json';
import pt_BR_assets from './locales/pt-BR/assets.json';
import pt_BR_supportWidget from './locales/pt-BR/supportWidget.json';
import pt_BR_permissions from './locales/pt-BR/permissions.json';

// Define resources
const resources = {
  en: {
    translation: en_translation,
    auth: en_auth,
    devices: en_devices,
    users: en_users,
    errors: en_errors,
    ui: en_ui,
    messages: en_messages,
    reports: en_reports,
    menu: en_menu,
    home: en_home,
    settings: en_settings,
    analytics: en_analytics,
    provisioning: en_provisioning,
    onboarding: en_onboarding,
    commands: en_commands,
    templates: en_templates,
    configurations: en_configurations,
    discrepancies: en_discrepancies,
    divergenceLogs: en_divergenceLogs,
    bling: en_bling,
    analysisReports: en_analysisReports,
    dockLoading: en_dockLoading,
    dockFleetOverview: en_dockFleetOverview,
    logisticsOps: en_logisticsOps,
    assets: en_assets,
    supportWidget: en_supportWidget,
    permissions: en_permissions,
  },
  'pt-BR': {
    translation: pt_BR_translation,
    auth: pt_BR_auth,
    devices: pt_BR_devices,
    users: pt_BR_users,
    errors: pt_BR_errors,
    ui: pt_BR_ui,
    messages: pt_BR_messages,
    reports: pt_BR_reports,
    menu: pt_BR_menu,
    home: pt_BR_home,
    settings: pt_BR_settings,
    analytics: pt_BR_analytics,
    provisioning: pt_BR_provisioning,
    onboarding: pt_BR_onboarding,
    commands: pt_BR_commands,
    templates: pt_BR_templates,
    configurations: pt_BR_configurations,
    discrepancies: pt_BR_discrepancies,
    divergenceLogs: pt_BR_divergenceLogs,
    bling: pt_BR_bling,
    analysisReports: pt_BR_analysisReports,
    dockLoading: pt_BR_dockLoading,
    dockFleetOverview: pt_BR_dockFleetOverview,
    logisticsOps: pt_BR_logisticsOps,
    assets: pt_BR_assets,
    supportWidget: pt_BR_supportWidget,
    permissions: pt_BR_permissions,
  },
};

// Initialize i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'translation',
    ns: ['translation', 'auth', 'devices', 'users', 'errors', 'ui', 'messages', 'reports', 'menu', 'home', 'settings', 'analytics', 'provisioning', 'onboarding', 'commands', 'templates', 'configurations', 'discrepancies', 'divergenceLogs', 'bling', 'analysisReports', 'dockLoading', 'dockFleetOverview', 'logisticsOps', 'assets', 'supportWidget', 'permissions'],

    // Language detector options
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Pluralization: i18next v4 JSON — plural forms are `<key>_one` / `<key>_other`,
    // resolved with the default `_` separator. Do NOT set `pluralSeparator` here:
    // it is the SEPARATOR, not the suffix, so a value like '_plural' makes
    // i18next look up `<key>_pluralother` and silently fall back to the singular.

    // React-specific options
    react: {
      useSuspense: false, // Set to false to avoid Suspense issues during development
    },
  });

export default i18n;
